import React, { useEffect, useState } from 'react';
import isEmpty from 'lodash/isEmpty';
import { ButtonComp } from 'atoms/Buttons';
import { useHistory } from 'react-router-dom';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import ImageComponent from 'atoms/Image/index';
import { RESIZE, SESSION_STORAGE_KEYS } from 'common/constants/SharedConstants';
import { redirectToHomePage, isMobileDevice } from 'common/utilities/utils';
import { getAddHopeThankYouContentData } from '../utils/ThankYouUtils';
import { getAddHopeThankYouContent } from 'common/utilities/content';
import { contentfulActions, selectContentfulResponse } from '@kfc-global/react-shared/redux/Slices/ContentfulSlice';
import { useAppDispatch, useAppSelector } from '@kfc-global/react-shared/redux/Store/hooks';
import { Row } from 'reactstrap';
const ThankYou = () => {
  const [isMobile, setMobileHeader] = useState(isMobileDevice(window.innerWidth));
  const [segmentedThankYouData, setSegmentedThankYouData] = useState({});
  const dispatch = useAppDispatch();
  const history = useHistory();
  const thankYouContent = useAppSelector(selectContentfulResponse) ?? {};

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    sessionStorage.setItem(SESSION_STORAGE_KEYS.POST_PAYMENT_TYPE, '');
    dispatch(getAddHopeThankYouContent());
    return () => {
      dispatch(contentfulActions.resetReducer());
    };
  }, [dispatch]);

  const windowResized = () => {
    const isMobileView = isMobileDevice(window.innerWidth);
    setMobileHeader(isMobileView);
  };

  useEffect(() => {
    window.addEventListener(RESIZE, windowResized);
  }, [isMobile]);

  const gotToHome = () => {
    redirectToHomePage({ history });
  };
  useEffect(() => {
    if (!isEmpty(thankYouContent?.addHopeThankYou)) {
      setSegmentedThankYouData(getAddHopeThankYouContentData(thankYouContent?.addHopeThankYou?.items?.[0]?.fields));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [thankYouContent?.addHopeThankYou, history]);

  return (
    <div className='thankyou-container'>
      <div className='thankyou-header-container'>
        <Row className='thankyou-stripes-section'>
          <ImageComponent
            srcFile={isMobile ? IMAGE_PATH.StripsIconMobile : IMAGE_PATH.StripesIcon}
            className='stripes-img'
          />
        </Row>
      </div>
      <div className='main-text-addhope-thankyou'>{segmentedThankYouData?.description}</div>
      <div className='addhope-thankyou-confirm-button'>
        <ButtonComp data-testid='take-me-homeid' className='take-me-home-addhope-thankyou' onClick={gotToHome}>
          {segmentedThankYouData?.goToHomePageBtnText}
        </ButtonComp>
      </div>
      <div className='addhope-thankyou-bg-image'>
        <ImageComponent
          srcFile={isMobile ? segmentedThankYouData?.mobileImage : segmentedThankYouData?.desktopImage}
          className='addhope-thankyou-img'
        />
      </div>
    </div>
  );
};

export default ThankYou;
